import { Model } from 'modules/core/lib/mobx-rest'

export interface IFamilySituation {
  id: number
  employee_id: number
  civil_status: string | null
  number_of_dependants: number | null
}

class FamilySituation extends Model<IFamilySituation> {
  static getNull(employeeId: number): FamilySituation {
    return new FamilySituation({
      employee_id: employeeId,
      civil_status: null,
      number_of_dependants: null,
    } as IFamilySituation)
  }

  static urlRoot() {
    return '/payroll/family_situations'
  }

  save(attributes?: {}, options?: {}) {
    const withEmployeeId = {
      ...attributes,
      ...{
        employee_id: this.attributes.employee_id,
      },
    }

    return super.save(withEmployeeId, options)
  }
}

export default FamilySituation
